<template>
  <div class="bg-opacity-30 bg-gray-100 absolute w-full h-full left-0 top-0 z-30" :class="!emptyConfig && 'opacity-0 pointer-events-none'"></div>
</template>

<script>

import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(({
      emptyConfig: 'editor/emptyConfig',
    })),
  },
}

</script>
